import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { newCompany } from '../../../api/redux/slices/SuperAdmin';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToast } from '../../../components/modal';

const AddCompany = ({ addModalOpen, setAddModalOpen }) => {
    const dispatch = useDispatch();
    const [isFocus, setIsFocus] = useState(false);
    const token = localStorage.getItem('accesstoken');

    const [values, setValues] = useState({
        name: '',
        address: '',
        phone: '',
        fax: '',
        email: '',
        tva_code: '',
        r_c: '',
        customs_code: '',
    });

    const handleAdd = (e) => {
        e.preventDefault();
        
        // Only name is required
        if (!values.name.trim()) {
            showToast('Veuillez remplir le nom de la société', 'warn');
            return;
        }

        // Send null for empty optional fields
        const data = {
            name: values.name.trim(),
            address: values.address.trim() || null,
            phone: values.phone.trim() || null,
            fax: values.fax.trim() || null,
            email: values.email.trim() || null,
            tva_code: values.tva_code.trim() || null,
            r_c: values.r_c.trim() || null,
            customs_code: values.customs_code.trim() || null,
        };

        dispatch(newCompany({ token: token, data }))
            .unwrap()
            .then(() => {
                setValues({ 
                    name: '', 
                    address: '', 
                    phone: '', 
                    fax: '', 
                    email: '', 
                    tva_code: '', 
                    r_c: '', 
                    customs_code: '' 
                });
                toast.success('Société ajoutée', {
                    position: 'top-center',
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setAddModalOpen(false);
            })
            .catch((err) => {
                toast.error(err.error, {
                    position: 'top-center',
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };

    return (
        <div className={'modalcontainer ' + (addModalOpen && 'open')}>
            <div className={'modal ' + (addModalOpen && 'active')}>
                <form onSubmit={handleAdd}>
                    <div className='label-input'>
                        <label>Nom de la société <span style={{color: '#e74c3c'}}>*</span></label>
                        <input
                            type='text'
                            placeholder='Nom'
                            value={values.name}
                            onChange={(e) => {
                                setValues({ ...values, name: e.target.value });
                                setIsFocus(true);
                            }}
                            required
                        />
                    </div>
                    <div className='label-input'>
                        <label>Adresse <span style={{color: '#999', fontSize: '0.8rem'}}>(optionnel)</span></label>
                        <input
                            type='text'
                            placeholder='Adresse'
                            value={values.address}
                            onChange={(e) => {
                                setValues({ ...values, address: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Téléphone <span style={{color: '#999', fontSize: '0.8rem'}}>(optionnel)</span></label>
                        <input
                            type='text'
                            placeholder='Téléphone'
                            value={values.phone}
                            onChange={(e) => {
                                setValues({ ...values, phone: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Fax <span style={{color: '#999', fontSize: '0.8rem'}}>(optionnel)</span></label>
                        <input
                            type='text'
                            placeholder='Fax'
                            value={values.fax}
                            onChange={(e) => {
                                setValues({ ...values, fax: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Email <span style={{color: '#999', fontSize: '0.8rem'}}>(optionnel)</span></label>
                        <input
                            type='email'
                            placeholder='Email'
                            value={values.email}
                            onChange={(e) => {
                                setValues({ ...values, email: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Code TVA <span style={{color: '#999', fontSize: '0.8rem'}}>(optionnel)</span></label>
                        <input
                            type='text'
                            placeholder='Code TVA'
                            value={values.tva_code}
                            onChange={(e) => {
                                setValues({ ...values, tva_code: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Registre de commerce (R.C) <span style={{color: '#999', fontSize: '0.8rem'}}>(optionnel)</span></label>
                        <input
                            type='text'
                            placeholder='Registre de commerce'
                            value={values.r_c}
                            onChange={(e) => {
                                setValues({ ...values, r_c: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Code douane <span style={{color: '#999', fontSize: '0.8rem'}}>(optionnel)</span></label>
                        <input
                            type='text'
                            placeholder='Code douane'
                            value={values.customs_code}
                            onChange={(e) => {
                                setValues({ ...values, customs_code: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='submit-btns'>
                        <div className='add-btns'>
                            <button
                                className={isFocus ? 'button-nature' : 'button-nature-inactive'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setAddModalOpen(false);
                                }}
                            >
                                Annuler
                            </button>
                            <button
                                className={isFocus ? 'button-primary' : 'button-primary-inactive'}
                                type='submit'
                            >
                                Ajouter
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddCompany;